import type { AuctionItemView } from "@/hooks/useAuctionItems";

/** 경매 물건 데이터를 AI 분석 요청 메시지로 포맷팅 */
export function buildAnalysisMessage(item: AuctionItemView): string {
  const NL = "\n";
  const tenantLine = item.hasTenant
    ? "임차인 있음" + NL + "   (전입일/확정일자/배당요구 여부는 등기부등본 확인 후 추가 제공 예정)"
    : "임차인: 없음";

  return (
    "[강스터디 AI 권리분석 요청]" + NL +
    NL +
    "[Auction_Info]" + NL +
    "사건번호: " + item.caseNumber + NL +
    "법원: " + item.court + NL +
    "소재지: " + item.location + NL +
    "물건종류: " + item.propertyType + NL +
    "감정가: " + item.appraisedValue.toLocaleString() + "원" + NL +
    "현재 최저가: " + item.minimumPrice.toLocaleString() + "원" + NL +
    "유찰횟수: " + String(item.failureCount) + "회" + NL +
    "입찰예정일: " + item.auctionDate + NL +
    NL +
    "[현황 메모 / 사전 분석]" + NL +
    (item.rightsAnalysis || "등록된 전문가 권리분석 메모가 없습니다.") + NL +
    NL +
    "[Tenant_Info]" + NL +
    tenantLine + NL +
    NL +
    "[Non_Registry_Info]" + NL +
    "유치권 신고: 확인 필요 (현장 조사 요망)" + NL +
    "당해세: 확인 필요 (관할 세무서 확인 요망)" + NL +
    "위반건축물: 확인 필요 (건축물대장 확인 요망)" + NL +
    NL +
    "---" + NL +
    "위 물건에 대한 AI 권리분석을 요청합니다." + NL +
    "등기부 권리 내역(근저당권 설정일/채권액 등)은 실제 등기부등본 확인 후 추가 제공하겠습니다." + NL +
    "현재 정보를 바탕으로 예비 분석과 추가 확인 사항을 먼저 안내해 주세요!"
  );
}